import { FlexBox } from "components/Common/FlexBox"
import styled from "styled-components"
import { IMealTypePercent, IMealTypePercentItem } from "../types"
import AnimatedValue from "./AnimatedValue"

const IconBox = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: 22px;
`

const LegendLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 160%;
  color: rgba(255, 255, 255, 0.8);
`

const LegendCalories = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
  flex-shrink: 0;
  min-width: 100px;
  text-align: right;
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: flex-end;
  color: rgba(255, 255, 255, 0.8);
`

const LegendPercent = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
  color: rgba(255, 255, 255, 0.8);
  text-align: right;
  min-width: 40px;
  display: inline-block;
`

const CalUnit = styled.span`
  color: rgba(255, 255, 255, 0.4);
`

const MealTypePercentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 10;
`

const dimmedColor = "rgba(255, 255, 255, 0.4)"

const MealTypePercentItem = ({
  mealType,
  loading,
  disableAnimation,
}: {
  mealType: IMealTypePercentItem
  loading: boolean
  disableAnimation?: boolean
}) => {
  const isEmpty = mealType.value === 0

  return (
    <FlexBox
      $alignItems="center"
      $gap={10}
      style={{
        width: "100%",
        maxWidth: "100%",
        zIndex: 1,
        padding: "2px 0",
      }}
    >
      <IconBox>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <rect width="14" height="14" rx="4" fill={mealType.color} />
        </svg>
      </IconBox>

      <LegendLabel style={{ flex: 1 }}>{mealType.name}</LegendLabel>

      <LegendPercent style={isEmpty ? { color: dimmedColor } : undefined}>
        <AnimatedValue
          value={mealType.percent}
          loading={loading}
          suffix="%"
          emptyText="-"
          separator=","
          skipFirstTransition={false}
          disableAnimation={disableAnimation}
        />
      </LegendPercent>

      <LegendCalories style={isEmpty ? { color: dimmedColor } : undefined}>
        <AnimatedValue value={mealType.value} loading={loading} skipFirstTransition={false} disableAnimation={disableAnimation} />
        <CalUnit>cal</CalUnit>
      </LegendCalories>
    </FlexBox>
  )
}

const MealTypePercent = ({
  mealTypePercent,
  loading,
  disableAnimation,
}: {
  mealTypePercent: IMealTypePercent
  loading: boolean
  disableAnimation?: boolean
}) => {
  return (
    <MealTypePercentWrapper>
      {mealTypePercent.map((mealType) => {
        return (
          <MealTypePercentItem
            key={mealType.name}
            mealType={mealType}
            loading={loading}
            disableAnimation={disableAnimation}
          />
        )
      })}
    </MealTypePercentWrapper>
  )
}

export default MealTypePercent
